import { tc } from '../../lib/trackingContext';

type TrackArgs = {
  event: 'Email Signup Submitted';
  label: string;
  category: string;
  phoneProvided: boolean;
  utms?: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_content?: string;
    utm_term?: string;
  };
};

export const trackEmailSignup = (args: TrackArgs) => {
  tc.track(args.event, {
    addToTrackingEvent: {
      label: args.label,
      category: args.category,
      phoneProvided: args.phoneProvided,
      ...args.utms
    }
  });
};
